<template>
  <div class="prev-Month-Detail">
    <head-top head-title="上个月打卡统计" go-back="true"></head-top>
    <lay-overtime :earlyNum="earlyNum" :signNum="signNum" :lateNum="lateNum" :lackNum="lackNum" v-if="flag"></lay-overtime>
    <month-count :monthData="lastMonthData" v-if="flag"></month-count>
  </div>
</template>

<script>
import monthCount from '../common/monthCount.vue'
import headTop from '../header/Header.vue'
import layOvertime from '../common/layOvertime.vue'
import {getDakaData} from '../../api/jianli.js'

export default {
  name: 'PrevMonthCardDetail',
  data() {
    return {
      lastMonthData: [],
      lackNum: '',
      lateNum: '',
      signNum: '',
      earlyNum: '',
      flag: false
    }
  },
  components: {
    monthCount,
    headTop,
    layOvertime
  },
  created() {
    this._getPrevMonthDakaData()
  },
  methods: {
    _getPrevMonthDakaData() {
      getDakaData('lastMonth', this.$route.params.id).then(res => {
        this.lastMonthData = res.data.data
        this.lackNum = res.data.lackNum
        this.lateNum = res.data.lateNum
        this.signNum = res.data.signNum
        this.earlyNum = res.data.earlyNum
        this.flag = true
      })
    }
  }

}
</script>

<style lang="scss">
  .prev-Month-Detail{
    padding-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/content/PrevMonthCardDetail.vue